// extracted by mini-css-extract-plugin
var _1 = "KunZ3__entry";
var _2 = "KunZ3__heading";
export { _1 as "entry", _2 as "heading" }
